<!--LOADING-->
<ng-template [ngIf]="isLoading">
  <app-loading-page class="white-top-theme"></app-loading-page>
</ng-template>
<!--END LOADING-->
<!--HOME PAGE-->
<ng-template [ngIf]="!isLoading">
  <main class="homepage">
    <!--HOMEPAGE HERO BANNER-->
    <ng-container
      *ngTemplateOutlet="showHomePageBannerCarousel ? homeBannerCarousel : homeHeroBanner">
    </ng-container>
    <!--END HOMEPAGE HERO BANNER-->
    <ng-container *ngIf="showCourseFeature">
      <app-hero-banner
        [id]="'beyond_course_feature'"
        [title]="'Course Features'"
        [description]="
          'With an Education Learning Subscription, you’re provided access to our entire training catalog that’s built and delivered in formats that best suit your role. Self-study, eLearning, ILTs, etc. Knowledgeable instructors. Create your free account and try it out today'
        "
        [customButtonCss]="['btn-primary', 'larger-btn', 'padding-right-small']"
        [heroImageCss]="'course-feature-hero'"
        [displayCss]="['flexbox', 'flexwrap', 'flex-direction-row']"
        [alignContentCss]="['hero-wrapper-smaller-left', 'text-color-black']"
        [routeType]="routeTypes.EXTERNAL"
        [route]="'https://register.beyond.genesys.com'"
        [actionLabel]="'Get Started'">
      </app-hero-banner>
    </ng-container>
    <!--SUBSCRIPTION LIST-->
    <ng-container *ngIf="subscriptionTilesNew; then thenBlock; else elseBlock"></ng-container>
    <ng-template #thenBlock>
      <app-subscription-tiles></app-subscription-tiles>
    </ng-template>
    <ng-template #elseBlock>
      <app-legacy-subscription-tiles></app-legacy-subscription-tiles>
      <!--<app-subscription-list></app-subscription-list>-->
    </ng-template>
    <!--END SUBSCRIPTION LIST-->
    <!--TRUSTED PARTNER AND CUSTOMERS-->
    <app-trusted-partners *ngIf="showTrustedPartner"></app-trusted-partners>
    <!--END TRUSTED PARTNER AND CUSTOMERS-->

    <!--START FEATURED TILES -->
    <!--<app-card-container
      [containerBackgroundCss]="isLightMode ? 'neutral-background' : ''"
      [additionalCSS]="['wrapper-spacing']">
      <app-tile-layout maxColumns="3">
        <app-tile-vertical
          *ngFor="let tile of tiles"
          [title]="tile.title"
          [description]="tile.description"
          [link]="tile.link"
          [mediaUrl]="tile.mediaUrl"
          [mediaType]="tile.mediaType"
          [embedUrl]="tile.embedUrl">
        </app-tile-vertical>
      </app-tile-layout>
    </app-card-container>-->
    <!--END FEATURED TILES -->

    <!--CONTACT SALES NEW DESIGN -->
    <app-contact-sales
      *ngIf="showContactSales && contactSalesForm"
      [id]="'contactsales'"
      [heroImageCss]="['contact-us-hero', 'wrapper', 'margin-top-larger', 'margin-bottom-larger']"
      [displayCss]="['columns']"
      [alignContentCss]="['text-color-white', 'margin-right-large']"
      [showButton]="false"
      [formType]="''">
    </app-contact-sales>

    <!--CONTACT SALES OLD DESIGN -->
    <app-contact-sales
      *ngIf="showContactSales && !contactSalesForm"
      [id]="'contactsales'"
      [heroImageCss]="'contact-us-hero-old'"
      [displayCss]="['columns']"
      [alignContentCss]="['left-aside-column', 'text-color-white', 'margin-right-large']"
      [showButton]="false"
      [formType]="''">
    </app-contact-sales>
    <!--END CONTACT SALES-->
    <!--TESTIMONIALS-->
    <!--<app-testimonials
      [testimonials]="testimonials"
      [testimonialAlignmentCSS]="['testimonial-content', 'text-align-left', 'margin-right-large']"
      [testimonialWrapperCSS]="'testimonial-wrapper-center'"
      [testimonialBackgroundCSS]="'testimonials'"
      [arrowColorCSS]="'white'"></app-testimonials>-->
    <!--TESTIMONIALS-->
    <!--PROMOTED VIDEOS-->
    <app-promoted-videos *ngIf="showHomeVideoSection"></app-promoted-videos>
    <!--END PROMOTED VIDEOS-->
  </main>
</ng-template>

<ng-template #homeBannerCarousel>
  <app-banner-carousel
    *ngIf="showHomePageBannerCarousel"
    [id]="beyond_banner_carousel"
    [carouselDotActiveCSS]="'orange-active'"
    [carouselSectionCSS]="'homepage-billboard'"
    [carouselLeftArrowCSS]="['left-slider', 'arrow-left']"
    [carouselRightArrowCSS]="['right-slider', 'arrow-right']"
    [carouselItems]="images"
    [bannerPositionsCss]="[
      'background-position-center-x',
      'background-position-bottom-y',
      'background-repeat'
    ]">
  </app-banner-carousel>
</ng-template>

<ng-template #homeHeroBanner>
  <!-- New Banner -->
  <app-hero-banner
    *ngIf="homeBanner"
    [id]="'beyond_hero_banner'"
    [title]="infoItem?.title"
    [customHeadingCss]="['banner-home-title', 'text-align-center']"
    [description]="infoItem?.description"
    [customDescriptionCss]="'banner-home-desc'"
    [displayCss]="['home-banner-wrapper', 'justify-space-between', 'margin-bottom-large']"
    [alignContentCss]="[
      'hero-wrapper-center',
      'text-color-white',
      'padding-top-x-large',
      'padding-bottom-large',
      'flex-order',
      'margin-right-auto',
      'margin-left-large'
    ]"
    [routeType]="routeTypes.EXTERNAL"
    [customButtonCss]="['btn-primary', 'larger-btn', 'padding-right-small', 'font-size-button']"
    [route]="'https://register.beyond.genesys.com'"
    [actionLabel]="infoItem?.cta">
    <div content class="left-aside-column auto-margin-center hero-video">
      <app-video-container
        [title]="'This is Genesys Education'"
        [embedUrl]="'https://fast.wistia.net/embed/iframe/ep6pjjs15o?web_component=true&seo=true'"
        [containerCss]="['tile-border-radius', 'tile-box-shadow-black']">
      </app-video-container>
    </div>
  </app-hero-banner>

  <!-- Old Banner -->
  <app-hero-banner
    *ngIf="!homeBanner"
    [id]="'beyond_hero_banner'"
    [title]="infoItem?.title"
    [customHeadingCss]="['banner-home-title']"
    [description]="infoItem?.description"
    [customDescriptionCss]="'banner-home-desc'"
    [heroImageCss]="'beyond-home-hero'"
    [displayCss]="['flexbox', 'justify-space-between']"
    [alignContentCss]="[
      'hero-wrapper-smaller-left',
      'text-color-white',
      'padding-top-large',
      'padding-bottom-large'
    ]"
    [routeType]="routeTypes.EXTERNAL"
    [customButtonCss]="['btn-primary', 'larger-btn', 'padding-right-small', 'font-size-button']"
    [route]="'https://register.beyond.genesys.com'"
    [actionLabel]="infoItem?.cta">
    <!--<div content class="margin-right-large">
      <img
        class="beyond-home-hero-image"
        src="/assets/img/beyond-home-hero-old.png"
        alt="'Knowledge Without Limits hero banner image" />
    </div>-->
  </app-hero-banner>
</ng-template>
